<div class="time-picker" *ngIf="isVisible">
  <bzg-select  [value]="hours" (valueChange)="selectHour($event)" [(value)]="hours" class="ml-8 mr-8">
    <bzg-option *ngFor="let hour of hoursArray" [value]="hour" [ngClass]="{'selected-option': hour === hours}">{{hour}}</bzg-option>
  </bzg-select>
  <span class="separator">:</span>
  <bzg-select  [value]="minutes" (valueChange)="selectMinute($event)" class="ml-8 mr-8">
    <bzg-option *ngFor="let minute of minutesArray" [value]="minute" [ngClass]="{'selected-option': minutes === minute}">{{ minute }}</bzg-option>
  </bzg-select>
  <svg class="bz-icon bz-icon-ml" height="32px" width="32px" *ngIf="showIcon">
    <use href="#icon-timer"></use>
  </svg>
</div>
